import styled from "styled-components";
import {
  PositionProps,
  position,
  variant,
  layout,
  space,
  SpaceProps,
  LayoutProps,
} from "styled-system";
import { css } from "@styled-system/css";

import variants from "./variants";

interface BoxProps extends PositionProps, SpaceProps, LayoutProps {
  /**
  Available sizes: "small" |"large"
   */
  variant?: "small" | "large";
}

export interface VrmBoxProps extends BoxProps {
  /**
  Vrm code.
  */
  vrm: string;
  /**
  Available sizes: "small" |"large"
   */
  variant?: "small" | "large";
}

const VrmBox = styled.div<BoxProps>`
  border-left: 10px solid #2196f3;
  border-radius: 3px;
  font-weight: bold;
  text-align: center;
  box-shadow: 0 2px 9px 0 rgba(65, 65, 65, 0.1);
  text-transform: uppercase;
  background-color: #fff;
  ${position};
  ${space};
  ${layout};
  ${variant({
    variants,
  })};
  ${css({
    fontSize: "body-small",
    fontWeight: "bold",
  })}
`;

const Vrm = ({ vrm, variant = "small", ...props }: VrmBoxProps) => {
  return (
    <VrmBox
      minWidth={84}
      minHeight={25}
      variant={variant}
      aria-label="chip"
      {...props}
    >
      {vrm}
    </VrmBox>
  );
};

export default Vrm;
